module.exports = __webpack_public_path__ + "img/portrait-014.c3e69697.jpg";